import { useState } from 'react';
import type { AuthData } from './auth-client.js';
import { authenticateLocalAcceptance } from './auth-client.js';
import { ApiClientError } from './api.js';
import { AsyncState, Button, Screen } from './ui.js';
export { localAcceptanceEnabled } from './local-acceptance-guard.js';

export function LocalAcceptanceLogin({
  onAuthenticated,
}: {
  onAuthenticated: (result: AuthData) => void;
}) {
  const [error, setError] = useState<ApiClientError | null>(null);
  const [pending, setPending] = useState(false);
  const login = (user: 'new' | 'one' | 'two') => {
    setPending(true);
    setError(null);
    void authenticateLocalAcceptance(user)
      .then(onAuthenticated)
      .catch((reason: unknown) =>
        setError(
          reason instanceof ApiClientError
            ? reason
            : new ApiClientError('NETWORK_ERROR', 'Нет соединения'),
        ),
      )
      .finally(() => setPending(false));
  };
  return (
    <Screen title="Local acceptance" eyebrow="Только localhost">
      <p className="lead">Выберите синтетический локальный тестовый профиль.</p>
      <Button onClick={() => login('new')} disabled={pending}>
        Новый пользователь
      </Button>
      <Button onClick={() => login('one')} disabled={pending}>
        Тестовый пользователь 1
      </Button>
      <Button tone="secondary" onClick={() => login('two')} disabled={pending}>
        Тестовый пользователь 2
      </Button>
      {error && (
        <AsyncState kind="error" {...(error.requestId ? { requestId: error.requestId } : {})} />
      )}
    </Screen>
  );
}
